$.ajaxSetup({ cache: false });

$.validator.addMethod("mustbetrue", function (value, element, param) {
    // check if dependency is met
    if (!this.depend(param, element))
        return "dependency-mismatch";
    return element.checked;
});
$.validator.unobtrusive.adapters.addBool("mustbetrue", "required");

var waitForFinalEvent = (function waitForFinalEvent() {
    var timers = {};
    return function (callback, ms, uniqueId) {
        if (!uniqueId) {
            uniqueId = "Don't call this twice without a uniqueId";
        }
        if (timers[uniqueId]) {
            clearTimeout(timers[uniqueId]);
        }
        timers[uniqueId] = setTimeout(callback, ms);
    };
})();

function setSelectedCurrency(currency) {
    $.post('/currency/set', {
        "": currency
    })
      .done(function () {
          window.location.reload(true);
      });
}

function removeSavedSearch(el) {
    $.post('/save-search/remove', {
        "": el.data('savedsearchid')
    })
      .done(function () {
          el.parents('div.savedSearch').remove();
          if ($('div.savedSearch').length === 0) {
              $('#noSavedSearches').show();
          }
      });
}

function saveAlertPreference(el) {
    $.post('/save-search/save-alert-preference', {
        SavedSearchId: el.data('savedsearchid'),
        AlertFrequency: el.val()
    });
}

function saveSearch() {
    $.post('/save-search', {
        SearchUrl: window.location.href,
        SearchLocation: $('#searchLocation').text()
    })
      .done(function () {
          $('.saveSearch').html('<svg class="svg svg-icon-check"><use xlink:href="/public/img/svg/symbol-defs.svg#svg-icon-check"></use></svg> Search saved!').removeClass('btn-default').addClass('btn-success');
      });
}

function addToWatchList(el) {
    $.post('/watch-list/add', {
        ListingId: el.data('listingid')
    })
      .done(function (watchListItemId) {
          el.html('<svg class="svg svg-icon-heart"><use xlink:href="/public/img/svg/symbol-defs.svg#svg-icon-heart"></use></svg> In your watchlist');
          el.addClass('btn-danger saved active');
          el.removeClass('btn-info');
          el.data('watchlistitemid', watchListItemId);
      });
}

function deleteFromWatchListButton(el) {
    $.post('/watch-list/delete', {
        WatchListItemId: el.data('watchlistitemid')
    })
      .done(function () {
          el.html('<svg class="svg svg-icon-heart"><use xlink:href="/public/img/svg/symbol-defs.svg#svg-icon-heart"></use></svg> Add to watchlist');
          el.addClass('btn-info');
          el.removeClass('btn-danger saved active');
          el.data('watchlistitemid', '');
      });
}

function deleteFromWatchList(el) {
    $.post('/watch-list/delete', {
        WatchListItemId: el.data('watchlistitemid')
    })
      .done(function () {
          el.parents('.listing').remove();
          if ($('.listing').length === 0) {
              $('#noWatchListItems').show();
              $('#watchSharePrint').hide();
          }
      });
}

function analyticsListingCallback(listingId, url) {
    $.ajax({
        headers: {
            "X-XSRF-Token": $("input[name='__RequestVerificationToken']").val()
        },
        type: 'POST',
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
        url: url,
        data: JSON.stringify(listingId)
    });
}

function analyticsListingImageView(listingId) {
    analyticsListingCallback(listingId, '/analytics/listing-image-view');
}

function analyticsShareEmail(listingId) {
    analyticsListingCallback(listingId, '/analytics/share-email');
}

function analyticsPrint(listingId) {
    analyticsListingCallback(listingId, '/analytics/print');
}

function analyticsShareFacebook(listingId) {
    analyticsListingCallback(listingId, '/analytics/share-facebook');
}

$('body').bind('focusin focus', function (e) {
    e.preventDefault();
});

function onProgress(value) {
    $('#language-result').html('Translating&#8230;');
}

function onError(error) {
    $('#language-result').html('Translation error, please try again');
}

function onComplete() {
    $('#language-result').html('<svg class="svg svg-icon-check text-success"><use xlink:href="/public/img/svg/symbol-defs.svg#svg-icon-check"></use></svg> Translated');
    Microsoft.Translator.Widget.domTranslator.showHighlight = false;
    Microsoft.Translator.Widget.domTranslator.showTooltips = false;
}

function fillList(listOfLanguages, listId) {
    var languageList = document.getElementById(listId);
    for (var key in listOfLanguages) {
        var languageOption = document.createElement('div');
        var languageLink = document.createElement('a');
        languageOption.className = 'sidebar-message';
        // languageLink.setAttribute("href", "javascript:void(0)");
        languageLink.setAttribute("onclick", "$('#current-language').html('" + listOfLanguages[key].Name + "');Cookies.set('languageTranslateCode', '" + listOfLanguages[key].Code + "', { expires: 7 });Cookies.set('languageTranslateName', '" + listOfLanguages[key].Name + "', { expires: 7 });Microsoft.Translator.Widget.Translate('en', '" + listOfLanguages[key].Code + "', onProgress, onError, onComplete);");
        languageLink.innerHTML = listOfLanguages[key].Name;
        languageLink.className = 'p-sm';
        languageOption.appendChild(languageLink);
        languageList.appendChild(languageOption);
    }
}

function calculateFromNow(){
    $('.from-now').each(function () {
        var eventTime = moment($(this).data('time'));
        var tomorrow = moment().add(1, 'day');
        var calculate = eventTime.fromNow();
        if (eventTime.isSame(tomorrow, 'day')) {
            $(this).html('tomorrow!');
        }
        else {
            $(this).html(calculate);
        }
    });
}

$(document).ready(function () {

    if ($('.sitemap.treeview').length > 0) {
        $('.sitemap.treeview .hitarea').click(function () {
            $(this).siblings('ul').toggle();
            if ($(this).siblings('ul').is(':visible')) {
                $(this).addClass('expanded');
            } else {
                $(this).removeClass('expanded');
            }
        });
    }

    $('#share, #print').click(function () {
        var listingId = $(this).parents('[data-listingid]').data('listingid');
        analyticsListingImageView(listingId);
    });

    $('#main-search-input').autocomplete({
        serviceUrl: '/search-api/everything-search',
        dataType: 'json',
        transformResult: function (response) {
            return {
                suggestions: $.map(response, function (dataItem) {
                    return {
                        value: dataItem.Text,
                        data: {
                            category: dataItem.Category,
                            id: dataItem.Id
                        }
                    };
                })
            };
        },
        triggerSelectOnValidInput: false,
        minChars: 3,
        maxHeight: 'auto',
        groupBy: 'category',
        onSelect: function (suggestion) {
            var autocompleteredirect = true;
            if ($(this).attr('data-autocompleteredirect') &&
                $(this).attr('data-autocompleteredirect').length > 0) {
                if (!$(this).data('autocompleteredirect'))
                    autocompleteredirect = false;
            }
            if (autocompleteredirect) {
                if (suggestion.data.category === 'Agents') {
                    $('form#newSearchForm')
                      .attr('action', '/Franchises/ShortAgentUrl/' + suggestion.data.id)
                      .submit();
                } else if (suggestion.data.category === 'Offices') {
                    $('form#newSearchForm')
                      .attr('action', '/Franchises/ShortUrl/' + suggestion.data.id)
                      .submit();
                }
            }
        }
    });

    $('#top-nav-search-input').autocomplete({
        serviceUrl: '/search-api/everything-search',
        dataType: 'json',
        transformResult: function (response) {
            return {
                suggestions: $.map(response, function (dataItem) {
                    return {
                        value: dataItem.Text,
                        data: {
                            category: dataItem.Category,
                            id: dataItem.Id
                        }
                    };
                })
            };
        },
        triggerSelectOnValidInput: false,
        minChars: 3,
        maxHeight: 'auto',
        forceFixPosition: true,
        appendTo: '#topNavigationSearch',
        groupBy: 'category',
        zIndex: 1040,
        onSelect: function (suggestion) {
            var autocompleteredirect = true;
            if ($(this).attr('data-autocompleteredirect') &&
                $(this).attr('data-autocompleteredirect').length > 0) {
                if (!$(this).data('autocompleteredirect'))
                    autocompleteredirect = false;
            }
            if (autocompleteredirect) {
                if (suggestion.data.category === 'Agents') {
                    $('form#keywordsSearchFormNav')
                      .attr('action', '/Franchises/ShortAgentUrl/' + suggestion.data.id)
                      .submit();
                } else if (suggestion.data.category === 'Offices') {
                    $('form#keywordsSearchFormNav')
                      .attr('action', '/Franchises/ShortUrl/' + suggestion.data.id)
                      .submit();
                }
            }
        }
    });

    $('#footer-nav-search-input').autocomplete({
        serviceUrl: '/search-api/everything-search',
        dataType: 'json',
        transformResult: function (response) {
            return {
                suggestions: $.map(response, function (dataItem) {
                    return {
                        value: dataItem.Text,
                        data: {
                            category: dataItem.Category,
                            id: dataItem.Id
                        }
                    };
                })
            };
        },
        triggerSelectOnValidInput: false,
        minChars: 3,
        maxHeight: '300',
        groupBy: 'category',
        onSelect: function (suggestion) {
            var autocompleteredirect = true;
            if ($(this).attr('data-autocompleteredirect') &&
                $(this).attr('data-autocompleteredirect').length > 0) {
                if (!$(this).data('autocompleteredirect'))
                    autocompleteredirect = false;
            }
            if (autocompleteredirect) {
                if (suggestion.data.category === 'Agents') {
                    $('form#keywordsSearchFormFooter')
                      .attr('action', '/Franchises/ShortAgentUrl/' + suggestion.data.id)
                      .submit();
                } else if (suggestion.data.category === 'Offices') {
                    $('form#keywordsSearchFormFooter')
                      .attr('action', '/Franchises/ShortUrl/' + suggestion.data.id)
                      .submit();
                }
            }
        }
    });
    
    calculateFromNow();

    if (window.navigator.standalone === true) {
        $('.history-buttons').removeClass('hide');
        $('body').addClass('standalone');
        $('#right-sidebar').css('top', '80px');
        $('#page-wrapper').css('margin-top', '80px');
        $('#right-sidebar,.navbar-fixed-top').css('top', '20px');
    }

    function isRunningStandalone() {
        return (window.matchMedia('(display-mode: standalone)').matches);
    }
    if (isRunningStandalone()) {
        $('.history-buttons').removeClass('hide');
    }

    if (window.navigator.standalone === true) {
        $('.history-buttons').removeClass('hide');
        $('#right-sidebar').css('top', '80px');
        $('#page-wrapper').css('margin-top', '80px');
        $('#right-sidebar,.navbar-fixed-top').css('top', '20px');
    }

});

$(document).on('click', '.megamenu .dropdown-menu', function (e) {
    e.stopPropagation();
});